import React, { FC } from 'react'

const CloseStroke: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
  >
    <path
      fill="#EC1C24"
      fillRule="evenodd"
      d="M18 .367c9.941 0 18 8.059 18 18 0 9.94-8.059 18-18 18s-18-8.06-18-18c0-9.941 8.059-18 18-18Zm0 4c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14Zm-4.586 6.586a2 2 0 1 0-2.828 2.828l4.586 4.586-4.586 4.585a2 2 0 1 0 2.828 2.829L18 21.195l4.586 4.586a2 2 0 1 0 2.828-2.828l-4.586-4.586 4.586-4.586a2 2 0 1 0-2.828-2.829L18 15.539l-4.586-4.585Z"
      clipRule="evenodd"
    />
  </svg>
)

export default CloseStroke
